import { PickupDistribution } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getRateEnabled } from '@mews-commander/legacy-entities/src/ducks/rates';
import { getReservationGroupIdsByAvailabilityBlockId } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { canCurrentEmployeeManageReservations } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { getReservationUrl } from '../../../router/selectors';
import { openModal } from '../../app';
import { getBlockAdjustmentAvailableNumber } from '../selectors';
import { useAvailabilityBlockInfo } from './useAvailabilityBlockInfo';

export const usePickUpReservation = (availabilityBlockId: string) => {
    const dispatch = useCommanderThunkDispatch();
    const { availabilityBlock, isConfirmed } = useAvailabilityBlockInfo(availabilityBlockId);

    const rateId = availabilityBlock?.rateId;

    const enterpriseId = useCurrentEnterpriseId();
    const canManageReservations = useCommanderSelector(canCurrentEmployeeManageReservations);
    const isRateEnabled = useCommanderSelector((state) => (rateId ? getRateEnabled(state, { rateId }) : false));
    const availableCount = useCommanderSelector((state) =>
        getBlockAdjustmentAvailableNumber(state, { availabilityBlockId })
    );

    const [reservationGroupId] = useCommanderSelector((state) =>
        getReservationGroupIdsByAvailabilityBlockId(state, { availabilityBlockId, enterpriseId })
    );

    const newReservationUrl = useCommanderSelector((state) =>
        getReservationUrl(state, {
            GroupId:
                availabilityBlock?.pickupDistribution === PickupDistribution.AllInOneGroup
                    ? reservationGroupId
                    : undefined,
            AvailabilityBlockId: availabilityBlockId,
        })
    );

    if (!canManageReservations || !isRateEnabled || availableCount === 0 || !isConfirmed) {
        return null;
    }

    return () => {
        dispatch(openModal(newReservationUrl));
    };
};
